// extracted by mini-css-extract-plugin
module.exports = {"form":"xw","invalid":"yw","error":"zw","disabled":"Aw","invalidMsg":"Bw","note":"Cw"};